import { cn } from "@/lib/utils";

export default function ReportLoader({
  message = "Here we go",
  showProgressBar = true,
  showText = true,
  pending_count,
  total_count,
  completing = false,
}: {
  message?: string;
  showProgressBar?: boolean;
  showText?: boolean;
  pending_count?: number;
  total_count?: number;
  /** When true, the progress bar quickly animates to 100% before data is shown */
  completing?: boolean;
}) {
  const hasCounts =
    typeof pending_count === "number" &&
    typeof total_count === "number" &&
    total_count > 0;
  const progressPct = hasCounts
    ? Math.min(100, Math.max(0, ((total_count - pending_count) / total_count) * 100))
    : 0;
  const useCountProgress = hasCounts;

  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-[18px] m-auto">
      {showText && (
        <span className="overflow-hidden text-brand-primary-new text-center text-ellipsis text-[12px] font-medium leading-[19.157px] tracking-[0.24px]">
          {message}
        </span>
      )}
      <div
        className={`relative bg-[#EAECF0] h-[3px] rounded-full w-[200px] ${
          showProgressBar ? "visible" : "invisible"
        }`}
      >
        <div
          className={cn(
            "bg-brand-orange h-[3px] rounded-full",
            completing
              ? "transition-all duration-500 ease-out w-[100%]"
              : showProgressBar && !useCountProgress
                ? "animate-progress w-[0%]"
                : "w-[0%]",
            !completing && useCountProgress && "transition-all duration-500",
          )}
          style={
            !completing && useCountProgress
              ? { width: `${progressPct}%` }
              : undefined
          }
        />
      </div>
    </div>
  );
}
